import { NgModule } from '@angular/core';
import { Routes, RouterModule, UrlSegment } from '@angular/router';

import { SellerPaymentPageComponent } from './seller-payment-page.component';
import { CustomerInformationResolver } from './resolvers/customer-information.resolver';
import { TransferMethodResolver } from './resolvers/transfer-method.resolver';
import { PendingFormGuard } from './guard/pending-form.guard';

export function getPaidPathMatcher(url: UrlSegment[]) {
  const path = url.join('/');

  if (path.startsWith('get-paid')) {
    return { consumed: [url[0]] };
  }

  return null;
}

const routes: Routes = [
  {
    path: '**',
    component: SellerPaymentPageComponent,
    resolve: {
      customerInformation: CustomerInformationResolver,
      transferMethod: TransferMethodResolver
    },
    canDeactivate: [PendingFormGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SellerPaymentPageRoutingModule {}
